module.exports = __webpack_public_path__ + "img/56.6e164e83.svg";